/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { PatchOutcomeSuggestionResponse, PatchOutcomeSuggestionVars } from '../openapi-types.gen.js';

export type { PatchOutcomeSuggestionResponse, PatchOutcomeSuggestionVars } from '../openapi-types.gen.js';

export const usePatchOutcomeSuggestion = createMutationHook<PatchOutcomeSuggestionVars, PatchOutcomeSuggestionResponse, unknown>({
  specName: 'usePatchOutcomeSuggestion',
  path: '/v1/markets/{pubkey}/outcome-suggestions/{id}',
  method: 'PATCH',
  resolveUrl: (vars: PatchOutcomeSuggestionVars) => `/v1/markets/${vars.pubkey}/outcome-suggestions/${vars.id}`,
  buildBody: (vars: PatchOutcomeSuggestionVars) => ({ label: vars.label, ticker: vars.ticker, imageUrl: vars.imageUrl }),
  parseResponse: (raw: unknown): PatchOutcomeSuggestionResponse => raw as PatchOutcomeSuggestionResponse,
  optimistic: [{
    queryKey: ['markets', 'list'],
    apply: (prev: any, vars: PatchOutcomeSuggestionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
